import { Epic } from 'redux-observable';
import { catchError, switchMap, map } from 'rxjs/operators';
import { ofType } from '@alycecom/utils';
import { handleError, handlers, IListResponse } from '@alycecom/services';
import { v4 } from 'uuid';
import { stringify } from 'query-string';

import { IBaseVerifiedAddress } from '../../types/Shipping.types';

import { loadAddressRequest, loadAddressSuccess, loadAddressFail } from './address.actions';

export const loadAddressEpic: Epic = (action$, state$, { apiService }) =>
  action$.pipe(
    ofType(loadAddressRequest),
    switchMap(({ payload: { hashId, countryId, address } }) =>
      apiService.get(`/api/recipient/${hashId}/address/autocomplete?${stringify({ countryId, address })}`).pipe(
        map(({ data }: IListResponse<IBaseVerifiedAddress>) =>
          loadAddressSuccess(data.map(addressItem => ({ ...addressItem, countryId, id: v4() }))),
        ),
        catchError(handleError(handlers.handleAnyError(loadAddressFail))),
      ),
    ),
  );

export const addressEpics = [loadAddressEpic];
